import { inject, Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

export const NUMBER_SVG = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
  <text x="2" y="17" font-family="Arial, sans-serif" font-size="14">0-9</text>
</svg>
`;

export const TEXT_SVG = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
  <text x="2" y="17" font-family="Arial, sans-serif" font-size="14">Aa</text>
</svg>
`;

export const DATE_SVG = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
  <circle cx="12" cy="12" r="9"/>
  <line x1="12" y1="12" x2="12" y2="7"/>   <!-- aiguille des minutes -->
  <line x1="12" y1="12" x2="15" y2="12"/>  <!-- aiguille des heures -->
</svg>
`;

export const BOOLEAN_SVG = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
  <path d="M9 16.2l-3.5-3.5 1.4-1.4L9 13.4l7.1-7.1 
    1.4 1.4z"/>
</svg>
`;

export const MULTI_SVG = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
  <path d="M4 4h16v2H4zM4 8h16v2H4zM4 12h16v2H4zM4 16h16v2H4z"/>
</svg>
`;

@Injectable({ providedIn: 'root' })
export class IconsService {
    /**
     * Constructor
     */
    constructor() {
        const domSanitizer = inject(DomSanitizer);
        const matIconRegistry = inject(MatIconRegistry);

        // Register icon sets
        matIconRegistry.addSvgIconSet(
            domSanitizer.bypassSecurityTrustResourceUrl(
                'icons/material-twotone.svg'
            )
        );
        matIconRegistry.addSvgIconSetInNamespace(
            'mat_outline',
            domSanitizer.bypassSecurityTrustResourceUrl(
                'icons/material-outline.svg'
            )
        );
        matIconRegistry.addSvgIconSetInNamespace(
            'mat_solid',
            domSanitizer.bypassSecurityTrustResourceUrl(
                'icons/material-solid.svg'
            )
        );
        matIconRegistry.addSvgIconSetInNamespace(
            'feather',
            domSanitizer.bypassSecurityTrustResourceUrl('icons/feather.svg')
        );
        matIconRegistry.addSvgIconSetInNamespace(
            'heroicons_outline',
            domSanitizer.bypassSecurityTrustResourceUrl(
                'icons/heroicons-outline.svg'
            )
        );
        matIconRegistry.addSvgIconSetInNamespace(
            'heroicons_solid',
            domSanitizer.bypassSecurityTrustResourceUrl(
                'icons/heroicons-solid.svg'
            )
        );
        matIconRegistry.addSvgIconSetInNamespace(
            'heroicons_mini',
            domSanitizer.bypassSecurityTrustResourceUrl(
                'icons/heroicons-mini.svg'
            )
        );

        matIconRegistry.addSvgIconLiteral(
            'type_number',
            domSanitizer.bypassSecurityTrustHtml(NUMBER_SVG)
        );
        matIconRegistry.addSvgIconLiteral(
            'type_string',
            domSanitizer.bypassSecurityTrustHtml(TEXT_SVG)
        );
        matIconRegistry.addSvgIconLiteral(
            'type_date',
            domSanitizer.bypassSecurityTrustHtml(DATE_SVG)
        );
        matIconRegistry.addSvgIconLiteral(
            'type_boolean',
            domSanitizer.bypassSecurityTrustHtml(BOOLEAN_SVG)
        );
        matIconRegistry.addSvgIconLiteral(
            'type_multi',
            domSanitizer.bypassSecurityTrustHtml(MULTI_SVG)
        );
    }
}
